import { AxiosResponseHeaders } from 'axios';
import { Device, DeviceData, DevicesResponseDTO } from '../entities';

const devicesDTOToDevicesAdapter = (data: DevicesResponseDTO, headers?: AxiosResponseHeaders): DeviceData => {
  if (!data.body) {
    throw new Error('Error');
  }

  const devices = data.body.devices || [];

  return {
    devices: devices.map(
      device =>
        new Device(device.deviceId, device.platform, device.deviceName, device.lastLogin, device.registrationDate),
    ),
    totalResults: data.body.totalResults || 1,
  };
};

export { devicesDTOToDevicesAdapter };
